var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-et",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M229.34 6.346H718.6v489.26H229.34z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(-240 -6.64) scale(1.046)",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc621",
    d: "M1.923 9.69h991.84v475.89H1.923z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef2118",
    d: "M0 333.64h993.18v161.97H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#298c08",
    d: "M1.923 6.346h991.93v172H1.923z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 534.22,
    rx: 199.65,
    cy: 352.97,
    transform: "matrix(.515 0 0 .515 204.68 77.013)",
    ry: 199.65,
    fill: "#006bc6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.08 186.19l-6.148 4.322 22.45 31.555 5.99-3.82-22.293-32.056zm28.103 74.482l-9.232-6.437 3.816-12.113-45.985.642-13.31-10.19 62.775-.677 11.642-35.27 6.253 14.26-15.957 49.785zm73.126-67.54l-5.978-4.553-23.295 30.935 5.45 4.554 23.822-30.938zm-62.507 49.296l3.347-10.745 12.7-.023-14.508-43.642 5.693-15.768 19.613 59.636 37.138.44-11.704 10.27-52.278-.167zm86.646 48.894l2.497-7.086-36.594-12.673-2.66 6.585 36.756 13.174zm-66.11-44.355l11.255-.113 3.922 12.08 37.08-27.206 16.754.577-50.733 36.974 10.983 35.48-13.368-7.987-15.89-49.806zm-18.87 97.55l7.51.11.348-38.726-7.09-.422-.77 39.038zm20.968-76.795l3.695 10.63-10.2 7.568 37.606 26.475 4.793 16.063-51.218-36.302-30.128 21.72 3.31-15.217 42.14-30.938zm-98.682 12.41l2.22 7.177 36.93-11.663-1.792-6.872-37.358 11.356zm79.514-3.842l-8.964 6.805-10.353-7.354-13.528 43.955-13.79 9.532 18.658-59.94-29.982-21.922 15.494-1.566 42.466 30.49z",
    fill: "#ffc621"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEt);
export default __webpack_public_path__ + "static/media/et.8e565b598fbd75d3d21639fd87f74925.svg";
export { ForwardRef as ReactComponent };